import { useState } from 'react';
import tableAPI from '../../api/tableAPI';

const parseError = (error, fallbackMessage) => {
  if (typeof error === 'string') return error;
  return error?.response?.data?.message || error?.message || fallbackMessage;
};

export default function useTableCart() {
  const [currentCart, setCurrentCart] = useState(null);
  const [cartLoading, setCartLoading] = useState(false);
  const [cartError, setCartError] = useState('');

  const fetchCartByTable = async (tableNumber) => {
    if (!tableNumber) {
      setCurrentCart(null);
      return null;
    }

    try {
      setCartLoading(true);
      setCartError('');
      const cart = await tableAPI.getActiveCartByTable(tableNumber);
      setCurrentCart(cart);
      return cart;
    } catch (error) {
      const message = parseError(error, 'Failed to load table cart');
      setCartError(message);
      setCurrentCart(null);
      return null;
    } finally {
      setCartLoading(false);
    }
  };

  const clearCart = () => {
    setCurrentCart(null);
    setCartError('');
  };

  return {
    currentCart,
    cartLoading,
    cartError,
    setCartError,
    fetchCartByTable,
    clearCart,
  };
}